import React from "react";
import { FaTimes } from "react-icons/fa";

const Modal = ({
  title = "Modal Title",
  children,
  isOpen,
  onClose,
  onSubmit,
  submitText = "Submit",
  cancelText = "Cancel",
  showFooter = true,
  closeOnOutsideClick = true,
}) => {
  if (!isOpen) return null;

  // Close modal when clicking outside content
  const handleOutsideClick = (e) => {
    if (closeOnOutsideClick && e.target.classList.contains("modal-overlay")) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOutsideClick}>
      <div className="modal">
        {/* Header */}
        <div className="modal-header">
          <h2>{title}</h2>
          <FaTimes className="close-icon" onClick={onClose} />
        </div>

        {/* Content */}
        <div className="modal-content">{children}</div>

        {/* Footer */}
        {showFooter && (
          <div className="modal-footer">
            <button className="cancel-btn" onClick={onClose}>{cancelText}</button>
            <button className="submit-btn" onClick={onSubmit}>{submitText}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
